export default __webpack_public_path__ + "static/media/lauryn_name.99b722f3.png";